// The assistant's share card (plan 2026-10-19-mcp-share-sources-request, D9;
// ADR-0479).
//
// On confirm the user's browser creates the share request and approves it,
// both under the user's own JWT: in the Verity chat the person confirming IS
// the person deciding. The backend's attach gate decides on approve (edit
// rights, own access to every source). When it refuses, or the call fails,
// the card must NOT read "Done": nothing was shared. It fails with the
// backend's reason and says the request is waiting in the dashboard's Data
// sources panel, where a colleague who may approve can do so (release review
// MAJ-1, 2026-10-19).
import { ApiError } from "@/api/client";
import { apiJson } from "@/api/dashboardMutations";
import { invalidateCompositionCatalog } from "@/components/dashboards/composition/useCompositionCatalog";
import { ActionError, registerAction } from "./registry";

export const PENDING_SUFFIX =
  "Nothing was shared. The request is saved: someone who can approve it finds it under Edit → Data sources on the dashboard.";

type CreateResponse = {
  status: "pending" | "already_shared";
  request: { request_id: string } | null;
};

registerAction("share_data_sources", async (params) => {
  const dashboardId = params.dashboard_id as string;
  const base = `/dashboards/${encodeURIComponent(dashboardId)}/share-requests`;
  const created = await apiJson<CreateResponse>(base, {
    method: "POST",
    body: JSON.stringify({ items: params.items }),
  });
  const dashboardLink = { label: "Open dashboard", to: `/insights/dashboards/${dashboardId}` };
  if (created.status === "already_shared" || !created.request) {
    return { resultRef: { dashboard_id: dashboardId }, link: dashboardLink };
  }
  const requestId = created.request.request_id;
  try {
    await apiJson(`${base}/${encodeURIComponent(requestId)}/approve`, { method: "POST" });
  } catch (err) {
    const reason =
      err instanceof ApiError && err.message && err.message !== "Request failed"
        ? err.message
        : "Approving did not go through.";
    throw new ActionError(`${reason.replace(/\.?$/, ".")} ${PENDING_SUFFIX}`);
  }
  invalidateCompositionCatalog();
  return { resultRef: { request_id: requestId }, link: dashboardLink };
});
